import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { Container, Spinner } from 'react-bootstrap';

//Protege a las rutas para que el usuario se necesite loguear.
export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
        <Container className="text-center mt-5 divfill">
            <Spinner animation="border" variant="dark" />
            <p>Cargando...</p>
        </Container>
    );
}

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
